export default function useForm(formRef) {
  const validateForm = async () => {
    return new Promise((resolve, reject) => {
      formRef.value?.validate(valid => {
        if (valid) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }
  
  return {
    validateForm,
  }
}